import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Wagons from '../../../../../../Wagons/Wagons';
import reserveSeat from '../../../../../../../utils/functions/reserveSeat';
import cancelSeatReserve from '../../../../../../../utils/functions/cancelSeatReserve';
import getGuidStatementClassPrices from '../../../../../../../utils/functions/getGuidStatementClassPrices';
import { useBooking } from '../../../../../../contexts/ticketBookingContext/TicketBookingContext';
import Statuses from '../chooseClasses/components/Statuses';
import { WagonContextProvider } from '../../../../../../contexts/wagonContext/wagonContext';
import { useModal } from '../../../../../../contexts/modalsContext/modalsContext';
import useTranslation from '../../../../../../hooks/translation/useTranslation';
import DesktopWatcher from '../../../../../../Wagons/DesktopWatcher';

function ChooseSeats({
  ride,
  statement,
  chosenSeats,
  setChosenSeats,
  direction,
}) {
  const { trans } = useTranslation();
  const { setShowErrorModal } = useModal();
  const [searchParams] = useSearchParams();
  const prices = getGuidStatementClassPrices(searchParams.get('guid'), ride.rideId);
  const [floor, setFloor] = useState(1);

  const { bookingData, setPrices } = useBooking();

  const getRideClassPrices = (rideId) => {
    let currentRide;
    if (bookingData?.departure?.id === rideId) {
      currentRide = bookingData?.departure;
    }
    if (bookingData?.return?.id === rideId) {
      currentRide = bookingData?.return;
    }
    const seatClassPrices = {};
    currentRide?.availableSeatsClasses?.forEach((seatClass) => {
      seatClassPrices[seatClass.seatClass.id] = seatClass.priceOfSeats.amount;
    });
    const seatGroupPrices = {};
    currentRide?.availableSeatsGroups?.forEach((seatClass) => {
      seatGroupPrices[seatClass.seatGroupProperty.id] = seatClass.priceOfSeats.amount;
    });
    return {
      seatClassPrices,
      seatGroupPrices,
    };
  };

  useEffect(() => {
    if (ride) {
      setPrices(getRideClassPrices(ride.rideId));
    }
  }, [ride]);

  const hasTwoStoryWagon = ride?.carriages?.find(
    (carriage) => [0, 1, 2, 3, 4, 100].includes(+(carriage?.carriage_map_id || 0)),
  );

  return (
    <div className="w-full flex flex-col gap-8">
      <Statuses />
      {hasTwoStoryWagon && (
      <button
        type="button"
        className="bg-transparent border-0 outline-0 flex items-center gap-4 self-end lg:hidden"
        onClick={() => {
          setFloor((prev) => {
            if (prev === 1) {
              return 2;
            }
            return 1;
          });
        }}
      >
        {
            floor === 2 && <i className="arrow rotate-[-225deg]" />
        }
        {trans('floor')}
        {' '}
        {floor}
        {
            floor === 1 && <i className="arrow right" />
        }
      </button>
      )}
      <div className="overflow-x-auto max-w-full">
        <WagonContextProvider direction={direction} floor={hasTwoStoryWagon ? floor : undefined}>
          <DesktopWatcher />
          <Wagons
            show
            data={ride}
            chosenSeats={chosenSeats}
            setChosenSeats={() => {
            }}
            reserveSeat={async (seat, wagonNumber) => {
              if (bookingData?.departure?.searchedDisabled) {
                setShowErrorModal(trans(
                  seat?.seat_group_property_id === 12
                    ? 'reserved_disabled_seat'
                    : 'reserved_standard_seat',
                ));
              } else if (seat?.seat_group_property_id === 12) {
                setShowErrorModal(trans(
                  'reserved_disabled_seat',
                ));
              }

              await reserveSeat({
                ride, statement, setChosenSeats, seat, wagonNumber, searchParams, prices,
              });
            }}
            unReserveSeat={async (seat, wagonNumber) => {
              await cancelSeatReserve(ride, statement, setChosenSeats, seat, wagonNumber);
            }}
          />
        </WagonContextProvider>
      </div>
    </div>
  );
}

export default ChooseSeats;
